import { FormGroup, FormBuilder } from '@angular/forms';
import { FormHumidityBuild } from './forms-build/form-humidity-build';

export class FormHumidity extends FormHumidityBuild {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            hibrido: ['', []],
            safra: ['', []],
            padrao_percentil: ['', []],
            umidade_maxima: ['', []]
        });
        return formulario;
    }
}
